export enum LDFeatureFlags {
    DisplayMode = 'DisplayMode',
    SportsHomeScreenYourFavouritesWidget = 'ld12-sports_homescreen_your_favourites_widget',
    FavouritesNavigationMenuPosition = 'ld11-sports_top_navigation_bar_favourites_position',
    ReuseSelections = 'MyBetsReuseSelections',
    PlayerStatsTracking = 'ld15-player_stats_bet_tracking',
    DefaultStreamingTab = 'DefaultStreamingTab',
    ESoccerInAZMenu = 'esoccer-in-az-menu',
    EnableLiveAlerts = 'EnableLiveAlerts',
}
export const LD_FEATURE_FLAG_STORAGE_KEY = 'LdFeatureFlags';
export const LD_FEATURE_FLAGS = [LDFeatureFlags.DisplayMode];
